import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import Header from "./LoginComponents/Header";
import SpotlightBanner from "./LoginComponents/SpotlightBanner";
import IconListCard from "./LoginComponents/IconListCard";
import FeaturesGrid from "./LoginComponents/FeaturesGrid";
import SocialEmbedCard from "./LoginComponents/SocialEmbedCard";
import Footer from "./LoginComponents/Footer";
import { portalApi } from "./LoginComponents/api/portalApi";
import { useFetch } from "./LoginComponents/hooks/useFetch";
import {
  mapAnnouncement,
  mapCarouselSlides,
  mapCards,
  mapFeatureList,
  mapYoutube,
  mapInstagram,
  mapSolutions,
  mapListings,
} from "./LoginComponents/api/ibizAdapters";
import { BASE_CRM_URL } from "../../components/config/config";
import "./LoginComponents/index.css";
import ImageInfo from "./LoginComponents/ImageInfo";
import { filterActiveListings } from "./LoginComponents/utils/filterActiveListings";
import ProfileDirectoryGrid from "./LoginComponents/ProfileDirectoryGrid";
import classifiedsStatic from "./LoginComponents/data/classfiedsStatic.json";
import { Spin } from "antd";

const SigninThree = () => {
  const navigate = useNavigate();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [isPasswordVisible, setPasswordVisible] = useState(false);
  const [loading, setLoading] = useState(false);

  const { data: content, loading: contentLoading } = useFetch(
    portalApi.getIbizContent,
    [],
  );

  const apiListings = mapListings(content);
  const shouldUseFallbackListings =
    !contentLoading && (!apiListings || apiListings.length === 0);
  const listings = filterActiveListings(
    shouldUseFallbackListings ? classifiedsStatic.listings : apiListings,
  );

  console.log({
    contentLoading,
    apiListingsCount: apiListings?.length,
    shouldUseFallbackListings,
    finalListingsCount: listings?.length,
  });

  const announcement = mapAnnouncement(content);
  const slides = mapCarouselSlides(content);
  const cards = mapCards(content);
  const features = mapFeatureList(content);
  const youtube = mapYoutube(content);
  const instagram = mapInstagram(content);
  const solutions = mapSolutions(content);
  const togglePasswordVisibility = () => setPasswordVisible((prev) => !prev);

  useEffect(() => {
    const userDetails = sessionStorage.getItem("userDetails");
    if (userDetails) {
      navigate("/crm/dashboard");
    }
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const trimmedUsername = username.replace(/\s/g, "");
      const trimmedPassword = password.replace(/\s/g, "");

      const payload = {
        Email: trimmedUsername,
        Password: trimmedPassword,
      };

      const response = await fetch(`${BASE_CRM_URL}Login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      if (response.ok && data.Status) {
        sessionStorage.setItem("userDetails", JSON.stringify(data.ResultData));
        setLoading(false);
        navigate("/crm/dashboard");
      } else {
        setLoading(false);
        Swal.fire({
          icon: "error",
          title: "Invalid Credentials",
          text:
            data?.Message ||
            "Please check your username and password and try again.",
          confirmButtonColor: "#f97316",
        });
      }
    } catch (error) {
      setLoading(false);
      console.error("Error during fetch:", error);
      Swal.fire({
        icon: "error",
        title: "Something went wrong",
        text: "An error occurred. Please try again.",
        confirmButtonColor: "#f97316",
      });
    }
  };

  return (
    <div className="min-vh-100">
      {/* Global Login Loader */}
      {loading && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
          style={{
            background: "rgba(255, 255, 255, 0.75)",
            zIndex: 9999,
          }}
        >
          <Spin size="large" tip="Signing in..." />
        </div>
      )}
      <Header
        announcement={announcement}
        contentLoading={contentLoading}
        username={username}
        setUsername={setUsername}
        password={password}
        setPassword={setPassword}
        isPasswordVisible={isPasswordVisible}
        togglePasswordVisibility={togglePasswordVisibility}
        onSubmit={handleSubmit}
        // loading={loading}
      />
      <Container fluid="xl">
        <Row className="g-3 pb-4">
          <Col className="px-0">
            <Spin spinning={contentLoading} tip="Loading..." size="large">
              <ProfileDirectoryGrid
                title="Whom We Work With"
                items={listings}
                loading={false}
              />
            </Spin>
          </Col>
        </Row>
      </Container>
      <Container fluid="xl" className="d-none">
        <Row className="g-3 py-4">
          <Col lg={7}>
            <SpotlightBanner slides={slides} loading={contentLoading} />
          </Col>
          <Col lg={5}>
            <ImageInfo
              title="Who we work with"
              items={solutions}
              loading={contentLoading}
            />
          </Col>
        </Row>

        <Row className="g-3 pb-4">
          <Col md={12} lg={5}>
            <IconListCard
              title="Explore Our Solutions"
              items={cards}
              loading={contentLoading}
            />
          </Col>
          <Col md={6} lg={3}>
            <FeaturesGrid
              title="Our other features"
              features={features}
              loading={contentLoading}
              limit={6}
            />
          </Col>
          <Col md={6} lg={4}>
            <SocialEmbedCard
              youtube={youtube}
              instagram={instagram}
              loading={contentLoading}
            />
          </Col>
        </Row>
      </Container>
      <Footer />
    </div>
  );
};

export default SigninThree;
